/**
 * Utilitários para geração de slugs
 */

/**
 * Gera um slug a partir de um texto, removendo acentos e caracteres especiais
 * @param text - Texto para converter em slug
 * @returns Slug gerado
 */
export function generateSlug(text: string): string {
  if (!text) return '';
  
  return text
    .toLowerCase()
    .normalize('NFD') // Normaliza caracteres Unicode
    .replace(/[\u0300-\u036f]/g, '') // Remove acentos
    .replace(/[^a-z0-9\s-]/g, '') // Remove caracteres especiais exceto espaços e hífens
    .replace(/\s+/g, '-') // Substitui espaços por hífens
    .replace(/-+/g, '-') // Remove hífens duplicados
    .replace(/^-|-$/g, ''); // Remove hífens do início e fim
}

/**
 * Gera slug para empresa com nome + ano
 * @param nomeEmpresa - Nome da empresa
 * @param ano - Ano (opcional, usa ano atual se não fornecido)
 * @returns Slug gerado no formato: nome-empresa-2025
 */
export function generateEmpresaSlug(nomeEmpresa: string, ano?: number): string {
  if (!nomeEmpresa) return '';
  
  const anoAtual = ano || new Date().getFullYear();
  const slugNome = generateSlug(nomeEmpresa);
  
  return `${slugNome}-${anoAtual}`;
}

/**
 * Valida se um slug é válido
 * @param slug - Slug para validar
 * @returns true se válido, false caso contrário
 */
export function isValidSlug(slug: string): boolean {
  if (!slug) return false;
  
  // Regex para validar slug: apenas letras minúsculas, números e hífens
  const slugRegex = /^[a-z0-9-]+$/;
  return slugRegex.test(slug) && slug.length > 0;
}

/**
 * Gera slug único adicionando sufixo numérico se necessário
 * @param baseSlug - Slug base
 * @param existingSlugs - Array de slugs existentes
 * @returns Slug único
 */
export function generateUniqueSlug(baseSlug: string, existingSlugs: string[] = []): string {
  if (!existingSlugs.includes(baseSlug)) {
    return baseSlug;
  }
  
  let counter = 1;
  let uniqueSlug = `${baseSlug}-${counter}`;
  
  while (existingSlugs.includes(uniqueSlug)) {
    counter++;
    uniqueSlug = `${baseSlug}-${counter}`;
  }
  
  return uniqueSlug;
}
